<template>
  <div
    class="lib-temp-sidebar"
    :style="{width:this.Window_Size.width+'px', height:this.Window_Size.height+'px'}"
  >
    <div
      class="loading-icon"
      :style="{width: dialogSize.width + 'px',height: dialogSize.height + 'px', left: dialogSize.left + 'px', top: dialogSize.top + 'px'}"
    >
      <transition name="el-fade-in">
        <div class="templib-usetemp-subwin" v-if="SideBarTemplate">
          <templateUse :template="SideBarTemplate"></templateUse>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import templateUse from "./contents/template/templateUse";
export default {
  components:{templateUse},
  name:"sideBarTemplateDialog",
  computed: {
    ...mapGetters(["Window_Size", "SideBarTemplate"]),
    dialogSize() {
      let width = Math.min(1226, this.Window_Size.width - 50);
      let height = Math.min(708, this.Window_Size.height - 50);
      let left = (this.Window_Size.width - width) / 2;
      let top = (this.Window_Size.height - height) / 2;
      return {
        width,
        height,
        left,
        top
      };
    }
  },
  mounted() {
    //console.log('this.Window_Size.width',this.Window_Size.width)
  }
};
</script>

<style lang="scss" scoped>
.lib-temp-sidebar {
  background: #ffffff77;
  .loading-icon {
    position: relative;
    top: 25px;
    left: 44px;
    background-color: transparent;
    box-shadow: 0px 0px 4px 0px rgba(54, 76, 204, 0.4);
    border-radius: 8px;
    border: 0px solid white;
    overflow: hidden;
    //使用模板弹窗
    .templib-usetemp-subwin {
      position: absolute;
      height: 100%;
      width: 100%;
      background-color: white;
      border-radius: 8px;
      overflow: hidden;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/emodal/templateLib/sideBarTemplateDialog.vue